import React, { useContext, Fragment } from 'react'
import PropTypes from 'prop-types'

import { SearchContext } from '../search/SearchContext'

import { InputText } from '../common/forms'
import {
  validateName,
  validatePhone,
  validateEmail,
  normalizePhone,
  normalizeName
} from '../helpers/formHelper'

import AddressFields from './AddressFields'
import {
  isTourOperator,
  isBookingAgentAndisBookingAnUpgrade,
  isBookingAgent,
  isTourOnlyUser,
  creditLimitUserHasNoSurcharge,
  shouldDisplayAddressFields
} from "../helpers/userHelper"

const BookingFields = ({ handler, errors, values, user, useExistingCard }) => {
  const { state } = useContext(SearchContext)

  const isBookRoomAndTourOperation = () => {
    return (state.booking.action == 'book_room_and_tour') && (isTourOperator(user) || isBookingAgent(user) || isTourOnlyUser(user))
  }
  return (
    <Fragment>
      <h3>Guest Details</h3>
      <p className="thin-p">
        This information should match the photo identification of the person who will be checking into the hotel.</p>
      <div className="fieldset">
        <InputText
          className={errors.firstName && 'error'}
          type="text"
          name="firstName"
          label="First Name"
          value={values.firstName}
          handler={handler}
          required={true}
          normalize={normalizeName}
          validate={validateName}
          readOnly={isBookingAgentAndisBookingAnUpgrade(state)}
          maxLength={40}
        />

        <InputText
          className={errors.lastName && 'error'}
          type="text"
          name="lastName"
          label="Last Name"
          value={values.lastName}
          handler={handler}
          required={true}
          normalize={normalizeName}
          validate={validateName}
          readOnly={isBookingAgentAndisBookingAnUpgrade(state)}
          maxLength={40}
        />

        {isBookRoomAndTourOperation() && (
          <Fragment>
            <InputText
              className={errors.spouseFirstName && 'error'}
              type="text"
              name="spouseFirstName"
              label="Spouse First Name"
              value={values.spouseFirstName}
              handler={handler}
              normalize={normalizeName}
              validate={validateName}
              readOnly={isBookingAgentAndisBookingAnUpgrade(state)}
              maxLength={40}
            />

            <InputText
              className={errors.spouseLastName && 'error'}
              type="text"
              name="spouseLastName"
              label="Spouse Last Name"
              value={values.spouseLastName}
              handler={handler}
              required={true}
              normalize={normalizeName}
              validate={validateName}
              readOnly={isBookingAgentAndisBookingAnUpgrade(state)}
              maxLength={40}
            />
          </Fragment>
        )}

        <InputText
          className={errors.email && 'error'}
          type="email"
          name="email"
          label="Email"
          value={values.email}
          handler={handler}
          required={true}
          validate={validateEmail}
          readOnly={isBookingAgentAndisBookingAnUpgrade(state)}
        />

        <InputText
          className={errors.phone && 'error'}
          type="phone"
          name="phone"
          label="Phone"
          value={values.phone}
          handler={handler}
          required={true}
          normalize={normalizePhone}
          validate={validatePhone}
          readOnly={isBookingAgentAndisBookingAnUpgrade(state)}
        />

        {shouldDisplayAddressFields(state, useExistingCard) && (
          <AddressFields handler={handler} values={values} errors={errors} />
        )}
      </div>
    </Fragment>
  )
}

BookingFields.propTypes = {
  handler: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    spouseFirstName: PropTypes.string,
    spouseLastName: PropTypes.string
  }),
  values: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    spouseFirstName: PropTypes.string,
    spouseLastName: PropTypes.string
  }),
  user: PropTypes.object,
  useExistingCard: PropTypes.bool
}

export default BookingFields
